<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style>
@font-face {
  font-family: "AvenirBook";
  src: local("AvenirBook"),
  url(./Fonts/AvenirBook.ttf) format("truetype");
}
@font-face {
  font-family: "telegrafico";
  src: local("telegrafico"),
  url(./Fonts/telegrafico.ttf) format("truetype");
}
</style>
